<template>
    <form class="container" @submit.prevent="sendAutoData">
        <div class="mb-3">
            <label for="last-name-input" class="form-label">Введите фамилию:</label>
            <input id="last-name-input" v-model.trim="autoData.lastName" type="text" class="form-control" required>
        </div>
        <div class="mb-3">
            <label for="name-input" class="form-label">Введите имя:</label>
            <input id="name-input" v-model.trim="autoData.name" type="text" class="form-control" required>
        </div>
        <div class="mb-3">
            <label for="middle-name-input" class="form-label">Введите отчество:</label>
            <input id="middle-name-input" v-model.trim="autoData.middleName" type="text" class="form-control">
        </div>
        <div class="mb-3">
            <label for="auto-number-input" class="form-label">Введите номер ТС:</label>
            <input id="auto-number-input" v-model.trim="autoData.number" type="text" class="form-control" :required="autoData.typePass === 'auto'">
        </div>
        <div class="mb-3">
            <label for="village-name" class="form-label">Введите наименование посёлка:</label>
            <input id="village-name" v-model.trim="autoData.villageName" type="text" class="form-control" required>
        </div>
        <div class="mb-3" v-if="autoData.villageName">
            <label for="number-plant-input" class="form-label">Введите номер участка:</label>
            <input id="number-plant-input" v-model="autoData.numberPlant" type="text" class="form-control">
        </div>
        <div class="mb-3">
            <label for="type-pass-select" class="form-label">Выберите тип пропуска:</label>
            <select id="type-pass-select" v-model="autoData.typePass" class="form-select" required>
                <option value="rfid">RFID</option>
                <option value="qr">QR</option>
                <option value="auto">Автомобильный номер</option>
            </select>
        </div>
        <div class="mb-3" v-if="autoData.typePass === 'rfid'">
            <label for="rfid-input" class="form-label">RFID:</label>
            <input id="rfid-input" v-model="autoData.rfid" type="text" class="form-control" required>
        </div>
        <div class="mb-3" v-else-if="autoData.typePass === 'qr'">
            <label for="phone-input" class="form-label">Номер телефона:</label>
            <input id="phone-input" v-model="autoData.phone" type="tel" class="form-control" required>
        </div>
        <div class="mb-3">
            <label for="access-type-select" class="form-label">Выберите тип доступа:</label>
            <select id="access-type-select" v-model="autoData.accessType" class="form-select">
                <option value="temporary">Временный</option>
                <option value="constant">Постоянный</option>
            </select>
        </div>
        <fieldset class="mb-3 border border" v-if="autoData.accessType === 'temporary'">
            <legend class="d-inline-block">Временный пропуск</legend>
            <div class="row mb-2">
                <label for="date-from-input" class="col-sm-3 col-form-label text-end">Начало периода:</label>
                <div class="col-sm-9">
                    <input id="date-from-input" type="date" v-model="autoData.dateFrom" class="form-control" />
                </div>
            </div>
            <div class="row mb-2">
                <label for="date-to-input" class="col-sm-3 col-form-label text-end">Конец периода:</label>
                <div class="col-sm-9">
                    <input id="date-to-input" type="date" v-model="autoData.dateTo" class="form-control" />
                </div>
            </div>
            <div class="row mb-2">
                <label for="entry-limit-input" class="col-sm-3 col-form-label text-end">Количество проходов(max:127):</label>
                <input id="entry-limit-input" type="number" v-model="autoData.entryLimit" step="1" min="1" class="form-control">
            </div>
        </fieldset>
        <div class="form-field">
            <img v-show="waite1" src="@/assets/wait.gif" class="waite" alt="" />
        </div>
        <div class="mb-3" v-show="!waite1">
            <label for="user-select" class="form-label">Выберите подразделение:</label>
            <select id="user-select" v-model="autoData.idUnit" class="form-select" required>
                <option v-for="(unit, key) in showUnit" :value="unit.ID" :key="key">{{
        unit.NAME
                    }}</option>
            </select>
        </div>
        <div class="mb-3" v-show="!waite1">
            <label for="group-select" class="form-label">Выберите группу доступа:</label>
            <select id="group-select" v-model="autoData.idGroup" class="form-select">
                <option v-for="(group, key) in groups" :value="group.ID" :key="key">{{
        group.NAME
                    }}</option>
            </select>
        </div>
        <div class="form-field">
            <img v-show="waite" src="@/assets/wait.gif" class="waite" alt="" />
            <button v-show="!waite" type="submit" class="btn btn-success">Отправить</button>
        </div>
        <div class="form-row" v-if="info">{{ info }}</div>
    </form>
</template>

<script>
    import config from "@/config";

    export default {
        name: "AutoPassAdd",
        data() {
            return {
                url: config.backend_url,
                units: [],
                groups: [],
                unitHaveChildren: [],
                autoData: {
                    name: null,
                    lastName: null,
                    middleName: null,
                    number: null,
                    numberPlant: null,
                    typePass: null,
                    accessType: null,
                    dateFrom: null,
                    dateTo: null,
                    entryLimit: null,
                    idUnit: null,
                    idGroup: false,
                    phone: null,
                    rfid: null,
                    villageName: null
                },
                info: false,
                waite1: false,
                waite: false
            };
        },
        computed: {
            showUnit: function () {
                let self = this;
                return this.units.filter(function (unit) {
                    return !self.unitHaveChildren.includes(unit.ID);
                });
            }
        },
        methods: {
            sendAutoData: function () {
                let self = this;
                self.waite = true;
                let data = {
                    url: self.url + "parsec/add-rfid/",
                    data: self.autoData,
                    method: "POST"
                };
                this.$store.dispatch("query/sendRequest", data).then(function (response) {
                    let data = response.data;
                    console.log(data);
                    if (data.error) {
                        self.info = data.error;
                    } else {
                        self.info = data.parsecPersonID
                                ? "ID пользователя: " + data.parsecPersonID
                                : "Ошибка добавления пропуска в Parsec";
                    }
                    self.waite = false;
                });
            }
        },
        mounted() {
            let self = this;
            self.waite1 = true;
            let data = {
                url: this.url + "parsec/get-units-hierarhy/",
                data: {},
                method: "POST"
            };
            this.$store
                    .dispatch("query/sendRequest", data)
                    .then(response => {
                        let data = response.data;
                        data.forEach(function (unit) {
                            if (!self.unitHaveChildren.includes(unit.PARENT_ID))
                                self.unitHaveChildren.push(unit.PARENT_ID);
                        });
                        if (!data.error) {
                            self.units = data;
                        } else {
                            self.info = "Ошибка получения списка подразделений";
                        }
                    })
                    .then(() => {
                        let data = {
                            url: this.url + "parsec/get-access-group/",
                            data: {},
                            method: "POST"
                        };
                        this.$store.dispatch("query/sendRequest", data).then(response => {
                            let data = response.data;
                            if (!data.error) {
                                self.groups = data;
                            } else {
                                self.info = "Ошибка получения списка групп";
                            }
                            self.waite1 = false;
                        });
                    });
        }
    };
</script>
